

import { BiListCheck } from "react-icons/bi";
import { IoTicketSharp } from "react-icons/io5";
import OrderCard from "../../Dashboard/OrderAmountDetails/OrderCard/OrderCard";
import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";

function EventOrderModal({
    targetID,
}) {

    const axiosInstance = useAxiosInstance();
    const [data, setData] = useState({});

    useEffect(() => {
        async function fetchAndSetEvents() {
            const { data } = await axiosInstance.get(`events/orderDetails/${targetID}`);
            setData(data);
        }
        fetchAndSetEvents();
    }, [targetID]);

    const {
        totalSoldTickets = 0,
        yesterdaySoldTickets = 0,
        todaySoldTickets = 0,
        last24HourSoldTickets = 0,
        last7DaysSoldTickets = 0,
        last15DaysSoldTickets = 0,
        last30DaysSoldTickets = 0,
    } = data;

    return (
        <div className="order_details_container">


            <OrderCard
                icon={<IoTicketSharp />}
                heading={"Total Sold Tickets"}
                total={totalSoldTickets}
            />


            <OrderCard
                icon={<IoTicketSharp />}
                heading="Yesterday Tickets Sold"
                total={yesterdaySoldTickets}
            />

            <OrderCard
                icon={<IoTicketSharp />}
                heading="Today Tickets Sold"
                total={todaySoldTickets}
            />

            <OrderCard
                icon={<IoTicketSharp />}
                heading="Last 24 Hours Tickets Sold"
                total={last24HourSoldTickets}
            />

            <OrderCard
                icon={<IoTicketSharp />}
                heading="Last 7 Days Tickets Sold"
                total={last7DaysSoldTickets}
            />

            <OrderCard
                icon={<IoTicketSharp />}
                heading="Last 15 Days Tickets Sold"
                total={last15DaysSoldTickets}
            />

            <OrderCard
                icon={<IoTicketSharp />}
                heading="Last 30 Days Tickets Sold"
                total={last30DaysSoldTickets}
            />
        </div>
    );
}

export default EventOrderModal;
